import React from "react";
import { Meta } from "../layout/Meta";

const PATH = "/connect-brokerage";
const TITLE = "How to connect your brokerage account";
const DESCRIPTION =
  "Learn how to connect your brokerage account in Stratify.";

export default function ConnectBrokeragePage() {
  return (
    <div className="min-h-[60vh] w-full bg-bg0">
      <Meta title={TITLE} description={DESCRIPTION} path={PATH} />
    </div>
  );
}
